<div class="border center backg pt-4">
    <h3>Complementos</h3>
    <mat-checkbox class="example-margin" (change)="changeTransporteInter($event.checked)">Transporte Internacional</mat-checkbox>
    <div class="row" *ngIf="showTransInternacional">
        <div class="col-lg-4">              
                <mat-form-field appearance="fill">
                    <mat-label>Pais Origen o Destino</mat-label>
                    <input type="text" 
                    placeholder="buscar pais" 
                    aria-label="Number" 
                    matInput
                    [formControl]="paisInput"
                    [matAutocomplete]="autoPais">
                    <mat-autocomplete autoActiveFirstOption #autoPais="matAutocomplete" [displayWith]="displayFuncionPais"
                        (optionSelected)="changePais($event.option.value.id)">
                        <mat-option *ngFor="let pais of _filteredPais | async" [value]="pais">
                            {{pais?.attributes?.idPais}} - {{ pais?.attributes?.nombre}}
                        </mat-option>
                    </mat-autocomplete>
                </mat-form-field>
        </div>
        <div class="col-lg-4">
            <mat-form-field appearance="fill">
                <mat-label>EntradaSalidaMerc</mat-label>
                <mat-select [(ngModel)]="idMovimiento" name="movimiento" (ngModelChange)="changeEntradaSal()">
                    <mat-option [value]="0">
                        Seleccionar
                    </mat-option>
                    <mat-option *ngFor="let tipo of tipoMovimiento" [value]="tipo.id">
                        {{tipo.attributes?.tipo}}
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </div>
        <div class="col-lg-4">
            <mat-form-field appearance="fill">
                <mat-label>ViaEntradaSalida</mat-label>
                <mat-select [(ngModel)]="idMovimientoVias" name="movimientoVias" (ngModelChange)="changeViaEntrada()">
                    <mat-option [value]="0">
                        Seleccionar
                    </mat-option>
                    <mat-option *ngFor="let movimiento of movimientoVias" [value]="movimiento.id">
                        {{movimiento.attributes?.clave}}-{{movimiento.attributes?.nombre}}
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </div>
    </div>
    <mat-grid-list cols="3" rowHeight="100px" height="400px">
        <!-- Transporte -->
        <mat-grid-tile>
            <mat-form-field appearance="fill">
                <mat-label>Tipo Transporte</mat-label>
                <mat-select [(ngModel)]="idTransporte" name="transporte" (ngModelChange)="changeTransporte()">
                    <mat-option *ngFor="let Transporte of Transportelist" [value]="Transporte.id">
                        {{Transporte.attributes?.tipo}}
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </mat-grid-tile>
        <mat-grid-tile>
        </mat-grid-tile>
        <!-- Translado -->
        <mat-grid-tile>
            <mat-form-field appearance="fill">
                <mat-label>Traslado por:</mat-label>
                <mat-select [(ngModel)]="idPTraslado" name="traslado" (ngModelChange)="changeTraslado()">
                    <mat-option *ngFor="let Traslado of PTrasladolist" [value]="Traslado.id">
                        {{Traslado?.attributes?.forma}}
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </mat-grid-tile>
    </mat-grid-list>
    <hr>

    <!--Ubicaciones-->
    <h4>Ubicaciones</h4>
    <div class="row justify-content-start align-items-center barraGestorPagos mb-4">
        <div class="col-sm-12 col-md-1 col-xl-1">
            <button (click)="addDomicilio()" mat-flat-button color="primary">
                <mat-icon svgIcon="heroicons_outline:plus-sm"></mat-icon>
            </button>
        </div>
        <div class="col-sm-12 col-md-1 col-xl-1">
            <button (click)="removeDomicilio()" [disabled]="removeDisabledDomicilio" mat-flat-button color="warn">
                <mat-icon svgIcon="heroicons_outline:minus-sm"></mat-icon>
            </button>
        </div>
    </div>

    <div class="row">
        <app-ubicaciones class="col-6" *ngFor="let p of countDomicilio" [idUbicacion]="p.idUbicacion"
            [idOperacion]="idOperacion" [title]="p.id" [changed]="addressChange" (AddressEmitter)="AddressEmitter($event)"
            (FormUbicacionEventEmiter)="FormUbicacionEventEmiter($event)"></app-ubicaciones>
    </div>

    <hr>

    <!--Mercancias-->
    <h4>Mercancias</h4>
    <div class="row justify-content-start align-items-center barraGestorPagos">
        <div class="col-sm-12 col-md-1 col-xl-1">
            <button (click)="addMercancia()" mat-flat-button color="primary">
                <mat-icon svgIcon="heroicons_outline:plus-sm"></mat-icon>
            </button>
        </div>
        <div class="col-sm-12 col-md-1 col-xl-1">
            <button (click)="removeMercancia()" [disabled]="removeDisabledMercancia" mat-flat-button color="warn">
                <mat-icon svgIcon="heroicons_outline:minus-sm"></mat-icon>
            </button>
        </div>
    </div>
    <hr>
    <div class="row">
        <div class="col-sm-3">
            <!-- <mat-label>Unidad Peso</mat-label> -->
            <!-- <mat-form-field appearance="fill">
                <mat-select [(ngModel)]="UnidadPeso">
                    <mat-option *ngFor="let item of lstUnidadPeso" [value]="item.id">
                        {{item.attributes?.clave}} - {{item.attributes?.nombre}}
                    </mat-option>
                </mat-select>
            </mat-form-field> -->

            <mat-form-field class="example-full-width" appearance="fill">
                <mat-label>Unidad Pesos</mat-label>
                <input matInput aria-label="State" matInput [formControl]="unidadPeso"
                    [matAutocomplete]="autoUnidadPeso" [(ngModel)]="UnidadPeso">
                <mat-autocomplete #autoUnidadPeso="matAutocomplete" [displayWith]="displayFn">
                    <mat-option *ngFor="let item of opcionesFiltradasUnidad | async" [value]="item.id"
                        style="height: 35px;">
                        <span> {{item.attributes?.clave}} - {{item.attributes?.nombre}}</span>
                    </mat-option>
                </mat-autocomplete>
            </mat-form-field>
        </div>
    </div>

    <hr>
    <app-mercancias class="mercancias" *ngFor="let p of countMercancia" [idMercancia]="idMercancia"
        [idOperacion]="idOperacion" [title]="p.id" [tipoTransporte]="idTransporte" [idMovimiento]="idMovimiento"
        (FormMercanciaEventEmiter)="FormMercanciaEventEmiter($event)"></app-mercancias>




    <!--Auto Transporte-->
    <br><br>
    <hr>
    <app-autotransporte class="mt-4" [idOperacion]="idOperacion" [idATransporte]="idATransporte"
        (FormTransporteEventEmiter)="FormTransporteEventEmiter($event)"></app-autotransporte>

    <app-transporte-aereo class="mt-4" *ngIf="idTransporte==2" [idOperacion]="idOperacion"
        [idTransporteAereo]="idTransporteAereo" [dataTransporteAereo]="dataTransporteAereo"></app-transporte-aereo>

    <app-ferroviarios #ferroviariosRef class="mt-4" *ngIf="idTransporte==3" [idOperacion]="idOperacion" [ferroviarios]="ferroviarios"
        [idTransporteFerro]="idTransporteFerro" [dataTransporteFerro]="dataTransporteFerro"
        (saveFerroviario)="saveFerroviario($event)" (DelFerroviario)="delFerroviario($event)" (resetFormulario)="resetFormulario($event)"></app-ferroviarios>

    <app-maritimo class="mt-4" *ngIf="idTransporte==4" [idOperacion]="idOperacion"></app-maritimo>

    <ng-container *ngIf="idTransporte==1">
        <!--Tipos Figura-->
        <hr>
        <h4>Tipos Figura</h4>
        <div class="row justify-content-start align-items-center barraGestorPagos">
            <div class="col-sm-12 col-md-1 col-xl-1">
                <button (click)="addTfigura()" mat-flat-button color="primary">
                    <mat-icon svgIcon="heroicons_outline:plus-sm"></mat-icon>
                </button>
            </div>
            <div class="col-sm-12 col-md-1 col-xl-1">
                <button (click)="removeTfigura()" [disabled]="removeDisabledTfigura" mat-flat-button color="warn">
                    <mat-icon svgIcon="heroicons_outline:minus-sm"></mat-icon>
                </button>
            </div>
        </div>
        <app-tipos-figura *ngFor="let p of countTfigura" [idFiguras]="idFiguras" [idOperacion]="idOperacion"
            [title]="p.id" (FormFigurasEventEmiter)="FormFigurasEventEmiter($event)"></app-tipos-figura>
    </ng-container>

</div>